export default __webpack_public_path__ + "static/media/bikelogin.a2d07d12.svg";